<template>
  <p class="critical"><i class="el-message-icon-warning"></i>本项目当前为DEMO状态，不代表最终品质。</p>
</template>

<script>
export default {
  name: 'InfoToggle',
  
}
</script>
<style scoped>
.critical {
  color: #e6a23c;
  background-color: #f6ecdc;
  margin: 10px 50px;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/InfoToggle.vue